/**
 * Picks a hypothesis's focus entities from the case graph by name: the shared `EntityPicker` with
 * the hypothesis form's copy.
 */
import { useTranslation } from 'react-i18next'
import {
  type EntityOption,
  EntityPicker,
  type EntitySearch,
} from '@/components/entity-picker/EntityPicker'

const COPY = 'analyticHypotheses.create'

export interface FocusEntityPickerProps {
  search: EntitySearch
  selected: readonly EntityOption[]
  onChange: (selected: EntityOption[]) => void
}

export function FocusEntityPicker(props: FocusEntityPickerProps) {
  const { t } = useTranslation()
  return (
    <EntityPicker
      {...props}
      copy={{
        label: t(`${COPY}.focusLabel`),
        placeholder: t(`${COPY}.focusPlaceholder`),
        hint: t(`${COPY}.focusHint`),
        searching: t(`${COPY}.focusSearching`),
        failed: t(`${COPY}.focusFailed`),
        noResults: t(`${COPY}.focusNoResults`),
        remove: name => t(`${COPY}.remove`, { name }),
      }}
    />
  )
}
